export default function getDirections() {
  console.log(google.maps.DirectionsRenderer)
}